<template>
  <div>
    <message-bubble :isMine=isMine :message=message>
      <template v-for="(item, index) of contentList">
        <span :key="index" v-if="item.name === 'text'" v-html="item.text" @click.prevent="textClick($event)"></span>
        <span :key="index + 1" v-if="item.name === 'evaluate_msg2'">
          <div>{{ item.text.guide_words }}</div>
          <div class="evaluate_msg" v-for="(v, i) of item.text.content" :key="i">
            <span @click="sendMoreEnterMsg(v.name, item.text.se_id, v.id)">{{ i + 1 + "." + v.name }}</span>
          </div>
        </span>
        <span :key="index + 2" v-else-if="item.name == 'evaluate_msg3'">
          <!-- <label style="font-size: 14px;">热门问题：</label> -->
          <el-tabs v-model="activeName">
            <el-tab-pane v-for="(ele, index1) in item.text" :key="index1" :label="ele.name" :name="ele.name">
              <div v-if="activeName == ele.name">
                <p v-for="(doc, index2) in ele.topics" :key="index2" class="tab_content"
                  @click.stop.prevent="pClick($event)"><i class="point_st"></i><span>{{ doc }}</span></p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </span>
        <span :key="index + 3" v-else-if="item.name == 'zhujian'">
          <p v-html="item.text.content" @click.prevent="textClick($event)" class="zhujianText"></p>
          <p style="text-align: center;margin-bottom: 0;" v-if="item.text.uuid">
            <el-button @click.prevent="clickUp(item)" class="upOrDownButton" v-if="upordown != 'down' && upordown != 'submitted'"
              :style="(upalreadyClicked || downalreadyClicked) ? { 'pointer-events': 'none' } : {}"
              :class="upalreadyClicked ? 'is-plain' : ''" size="mini"><img
                :src="upordown == 'up' ? imgObj['up'] : imgObj['up-nor']" class="clickImg">点赞一下</el-button>
            <el-button @click.prevent="openFeedback(item)" class="upOrDownButton" v-if="upordown != 'up'"
              :style="(upalreadyClicked || downalreadyClicked) ? { 'pointer-events': 'none' } : {}"
              :class="downalreadyClicked ? 'is-plain-down' : ''" size="mini"><img
                :src="upordown == 'down' || upordown == 'submitted' ? imgObj['down'] : imgObj['down-nor']" class="clickImg">继续加油</el-button>
          </p>
        </span>
        <img v-else-if="item.name === 'img'" :src="item.src" width="30px" height="30px" :key="index" />
        <span :key="index + 4" v-else v-html="item.content"></span>
      </template>
    </message-bubble>
    <div v-if="message.robot_type == 'ZhuJian' && upordown == 'up'" class="helpfulFeedback">
      谢谢您给我的赞，我会继续努力。
    </div>
    <div v-if="message.robot_type == 'ZhuJian' && upordown == 'down'" class="helpfulFeedback downFeedback">
      <span class="title">意见反馈</span>
      <div class="radio_box">
        <el-radio v-model="feedback" :label="item" size="medium" class="item" v-for="(item, index) in eval_class"
          :key="index">{{ item }}</el-radio>
      </div>
      <el-input type="textarea" class="textarea" placeholder="请输入意见" v-model="textarea" v-if="feedback" maxlength="300"
        show-word-limit>
      </el-input>
      <button @click="submitFeedback" class="fbSubBtn">提交</button>
    </div>
    <div v-if="hasSubmit" class="helpfulFeedback">
      抱歉，给您带来不好的体验，我会继续学习，下次为您提供更好的服务。
    </div>
  </div>
</template>
<script src="https://cdn.bootcdn.net/ajax/libs/vConsole/3.9.0/vconsole.min.js"></script>
<script>
import MessageBubble from '../message-bubble'
import RateElement from './rate-element'
import { decodeText } from '@/utils/decodeText'
import request from '@/utils/common_req'
import sessionAPI from '@/api/session'
import {mapState} from 'vuex'
export default {
  name: 'TextElement',
  components: {
    MessageBubble,
	RateElement
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    isMine: {
      type: Boolean
    }
  },
    data(){
      return{
          activeName : '',
          timer: null,
          upalreadyClicked: false,
          downalreadyClicked: false,
          upOrDownParams: { //点踩参数
            // appid:this.zhujianAppId,
            uuid:this.message.uuid,
            feedback: '', //helpful,unhelpful
            customFeedback : '',
            timestamp: Math.round(this.message.createTime / 1000)
          },
          upordown: '',
          feedback: '',
          textarea: '',
          hasSubmit: false,
          imgObj: {
                'up': require('@/assets/image/点赞.png'),
                'up-nor': require('@/assets/image/点赞-nor.png'),
                'down': require('@/assets/image/点踩.png'),
                'down-nor' : require('@/assets/image/点踩-nor.png')
         }
      }
    },
  methods:{
    //滚动到底部
    scrollToBottom() {
      const dom = document.querySelector(".message-list")
      this.$nextTick(() => {
        if(!dom) {
          return
        }
        // dom.scrollTop = dom.scrollHeight
        dom.scrollTop += 70
      })
    },
    sendEvaluateMsg(value,id){
      let map = {value:value,se_id:id}
      this.$bus.$emit('sendEvaluateMsg',JSON.stringify(map))
    },
    //多入口点击效果
    sendMoreEnterMsg(value,id,enterid){
      this.$store.commit('setEnterID',enterid)
      let map = {value:value,se_id:id}
      this.$store.commit({
          type: 'setNeedAssignCustomer',
          isNeedAssignCustomer: true
        })
      setTimeout(()=>{
        this.$bus.$emit('sendEvaluateMsg',JSON.stringify(map))
      },10)
    },
      clickUp(){
          this.upalreadyClicked = true
          this.upOrDownParams.feedback = 'helpful'
          this.upOrDownParams.appid = this.zhujianAppId
          sessionAPI.getChatEval(this.upOrDownParams).then(res => {
              if(res){
                  this.upalreadyClicked = true
                  this.upordown = 'up'
                  this.$message({
                      showClose: true,
                      message: res[0].value,
                      type: 'success'
                  })
                  localStorage.setItem(this.message.ID, 'up')
                  this.scrollToBottom()
              } else {
                this.$message({
                      showClose: true,
                      message: '点赞失败',
                      type: 'error'
                  })
              }
          }).catch(err => {
              this.upalreadyClicked = false
              this.$message({
                      showClose: true,
                      message: err.toString().indexOf('Error') > -1 ? '操作失败，请重试~' : err,
                      type: 'error'
                  })
          })
      },
      openFeedback() {
        this.downalreadyClicked = true
        this.upordown = 'down'
        this.scrollToBottom()
      },
      submitFeedback(){
          this.upOrDownParams.feedback = 'unhelpful'
          this.upOrDownParams.appid = this.zhujianAppId
          this.upOrDownParams.customFeedback = this.feedback + ';' + this.textarea
          if(!this.feedback) {
            this.$message({
                showClose: true,
                message: '请选择点踩原因',
                type: 'warning'
            })
          } else {
            sessionAPI.getChatEval(this.upOrDownParams).then(res => {
              if(res){
                  this.downalreadyClicked = true
                  this.$message({
                      showClose: true,
                      message: res[0].value,
                      type: 'success'
                  })
                  this.upordown = 'submitted'
                  this.hasSubmit = true
                  localStorage.setItem(this.message.ID, 'down')
              } else {
                  this.$message({
                      showClose: true,
                      message: '评价失败',
                      type: 'error'
                  })
              }
          }).catch(err => {
            console.log(err);
              this.downalreadyClicked = false
              this.$message({
                showClose: true,
                message: err.toString().indexOf('Error') > -1 ? '操作失败，请重试~' : err,
                type: 'warning'
              })
          })
          }

      },
      pClick(ev){
        let target = ev.target
        let msg = this.getChinese(target.innerText)
        this.sendEvaluateMsg(msg, '')
      },
    textClick(ev){
        let target = ev.target
        if (target.nodeName.toLowerCase() == 'a') {
            if (target.className.toLowerCase() == 'leave-word' || target.className.toLowerCase() == 'leave-enjoy') {
                var a = document.createElement('a');
                a.href = target.href + "&from=H5"
                a.click();
            } else if (target.className.toLowerCase() == 'out_queue') {
                request({
                    url: target.href,
                    method: 'GET',
                }).then(res => {
                    if(res.ret == 200){
                        target.className = 'remove_out_queue'

                    }
                })
            }else {
              if(target.href.startsWith('weixin')){
                    let msg = this.getChinese(target.innerText)
                    this.sendEvaluateMsg(msg, '')
                }else{
                    var a = document.createElement('a');
                    a.href = target.href
                    a.target = '_blank';
                    a.click();
                }
            }
        }
    },
    getChinese(strValue) {
        if(strValue!= null && strValue!= ""){
            var reg = strValue.replace(/^\w./,"") ///[\u4e00-\u9fa5]/g;
            return reg
        }else{
          return "";
        }
    }
  },
  watch: {
    upordown(newVal) {
      if(newVal != '') {
        document.querySelectorAll(".upOrDownButton").forEach(ele => {
          ele.style.border = 'none'
        })
      }
    }
  },
  computed: {
      ...mapState({
          memberList: state => state.group.currentMemberList,
          userID: state => state.user.userID,
          toAccount: state => state.conversation.toAccount,
          currentConversationType: state => state.conversation.currentConversationType,
          sign: state => state.conversation.sign,
          APPID: state => state.conversation.APPID,
          platform: state => state.conversation.platform,
          isNeedAssignCustomer: state => state.conversation.isNeedAssignCustomer,
          color: state => state.user.color,
          enterid: state => state.user.enterid,
          zhujianAppId: state => state.user.zhujianAppId,
          nickname: state => state.user.nickname,
          headimgurl: state => state.user.headimgurl,
          anonymity: state => state.user.anonymity,
          eval_class: state => state.conversation.eval_class
      }),
    contentList() {
      if(this.message.content && this.message.content.replace) {
        this.message.content = this.message.content.replace(/<img /g, '<img class="zhujianImgCls"')
      }
      if(this.message.evaluate_msg=='100'){
        let objMsg = JSON.parse(this.message.content)
        let content = `<div class="leave_msg_item"><span>问题类型：</span><div>${objMsg.type}</div></div><div class="leave_msg_item"><span>联系方式：</span><div>${objMsg.phone}</div></div><div class="leave_msg_item"><span>留言内容：</span><div>${objMsg.content}</div></div>`
        return [{
                name: 'text',   //留言
                text: content
              }]
        }else if(this.message.evaluate_msg=="2"){
        //入口选择
          let arr = [{
          name: 'evaluate_msg2',
          text:  {guide_words: '请选择咨询入口：',content: this.message.content}
          }]
          return arr
        }else if(this.message.evaluate_msg == '3'){
          let obj = this.message.content
            this.activeName = obj[0].name
            let arr = [{
                name: 'evaluate_msg3',
                text: obj
            }]
            return arr
        }else if(this.message.robot_type == 'ZhuJian'){
            return [{
                name: 'zhujian',
                text: this.message
            }]
        }else if (this.message.content.toString().includes('[')) {
          return decodeText(this.message.content)
        }else{

            let arr = [{
                name: 'text',
                text: this.message.content
            }]
            return arr
      }
    }
  },
  mounted() {
    const feedbackSaved = localStorage.getItem(this.message.ID)
    if(feedbackSaved == 'up') {
      this.upalreadyClicked = true
    } else if (feedbackSaved == 'down') {
      this.downalreadyClicked = true
    }
  }
}
</script>
<style>
.zhujianImgCls {
  max-width: 260px;
  border-radius: 5px;
}
</style>
<style lang="stylus" scoped>
/deep/.el-radio__input {
  display: none;
}
.fbSubBtn {
  height: 28px;
  background: $black;
  border-radius: 4px;
  color: #fff;
  border: none;
  margin-top 20px
  width 100%
  cursor: pointer;
}
.el-textarea__inner {
  background: #F8F8F8;
  border-radius: 4px;
}
.radio_box {
  width 100%
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
}
.radio_box .item {
  padding: 0 35px;
  width: 15%;
  height: 28px;
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 12px!important;
  color: #666666;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  margin-right: 10px;
  padding-left: -3px;
}
.radio_box .item:nth-child(2n) {
}
i.iconfont {
  margin-right: 5px;
}
.upOrDownButton {
  border: none;
  width: 47%;
  border-radius: 0;
  margin-left 0!important
}
.upOrDownButton:hover {
  background-color: #fff;
}
.upOrDownButton:first-child {
  border-right: 1px solid #DEDEDE;
}
.zhujianText {
  padding-bottom: 12px;
  border-bottom: 1px solid  #DEDEDE;
}
.helpfulFeedback {
  background-color #fff;
  border-radius: 0 8px 8px 8px;
  padding: 12px 16px;
  margin-top: 15px;
}
.downFeedback {
  max-width: 700px;
  height auto
  padding: 16px;
}
.downFeedback span.title {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-bottom: 12px;
}
.tab_content{
  margin: 0;
  color: #4582E6;
  cursor: pointer;
  margin-bottom: 8px;
  display: flex;
}
.tab_content:last-child{
  margin-bottom: 0;
}
.iconfont{
  font-size : 12px;
}
.is-plain{
    color: #151a20;
}
.is-plain-down {
  color:  #151A20;
  background-color #fff
}
.remove_out_queue{
    text-decoration:none;
    pointer-events :none;
    color:#1c2438;
}
.evaluate_msg{
    color: #366092;
    padding-top: 5px;
    &>span{
      cursor: pointer;
      &:hover{text-decoration: underline;}
    }
}
.downStyle{
    transform: rotate(180deg)
}
.el-tabs__nav-prev{
  line-height: 0;
}
.el-tabs__nav-next{
  line-height: 0;
}
.el-tabs__nav-scroll{
    height: 24px;
}
.el-tabs__active-bar{
  bottom: -4px;
  background: #fff linear-gradient(90deg, transparent 15px, #333 0px, #333 calc(100% - 15px), transparent calc(100% - 100%));
  z-index: 999;
}
.el-tabs__item{
  font-weight: 400;
  color: #666666;
  padding: 0 12px;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}
.el-tabs__item:hover{
  font-weight: 500;
  color: #333333;
}
.el-tabs__item.is-active{
  font-weight: 500;
  color: #333333;
}
.el-tabs__item{
    font-size 12px;
    height: 0;
    line-height: 0;
}
.el-tabs__nav-wrap::after{
  content: none;
}
.point_st{
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #4582E6;
  vertical-align: middle;
  margin-right: 7px;
  border-radius: 50%;
  margin-top: 6px;
}
.ser_deal_item_his{display:flex}
.leave_msg_item{
  display: flex;
  padding: 1px 0;
  &>div{
    display: flex;
    flex-wrap: nowrap;
    width: 189px;
  }
  &>span{
    width 60px
  }
}
.el-tabs.el-tabs--top{
    width: 264px;
}
.message-content span img{
  max-width : 660px;
}
.item.is-checked {
  color: #4582E6;
  background: rgba(69,130,230,0.10);
  border: 1px solid rgba(69,130,230,1);
}
/deep/.el-tabs__item.is-active{
  font-weight: 500;
  color: #4582E6;
}
/deep/.el-tabs__item:hover{
  font-weight: 500;
  color: #4582E6;
}
/deep/.el-tabs__active-bar {
  background-color #4582E6
}
/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #4582E6;
}
.el-button.is-plain:focus {
  color #151a20
}
/deep/.el-textarea__inner:focus {
  border-color: #4582E6;
}
.clickImg {
  position relative
  top 2px
  margin-right 4px
}
.el-button:focus, .el-button:hover {
  color #151a20
}
</style>